'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRespondersNameText = undefined;

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var getRespondersNameText = exports.getRespondersNameText = function getRespondersNameText(responders, locale) {
  return responders.map(function (responder) {
    return (0, _responderGetters.getFriendlyOrFormalName)(responder, locale) || (0, _responderGetters.getEmail)(responder);
  }).join(', ');
};